import React, { useCallback, useContext, useEffect, useState } from 'react';

import { BreakpointsContext } from '@src/providers/Breakpoints';
import { IItemClassName } from './models';
import { ILinkComponent, ISelectProps, IWithStylesProps } from '@src/models/props';
import { AnyType, TTabsTheme } from '@src/models/common';
import { classnames } from '@src/utils/classnames';
import { getClass } from '@src/utils/getClass';
import { TabItem } from './_Item/TabItem';

import styled from './Tab.scss';

interface ITabProps<TValue> extends IWithStylesProps, ILinkComponent, ISelectProps<TValue>, IItemClassName {
  /** Тема табов */
  theme?: TTabsTheme;
}

export const Tab = <TValue extends AnyType = AnyType>({
  options,
  className,
  style,
  itemClassName,
  onChange,
  value: propsValue,
  theme = 'light',
}: ITabProps<TValue>) => {
  const [value, setValue] = useState<TValue | undefined>(propsValue);

  const handleChange = useCallback(
    (v) => {
      setValue(v);
      onChange?.(v);
    },
    [onChange],
  );

  useEffect(() => {
    setValue(propsValue);
  }, [propsValue]);

  const { isMobile } = useContext(BreakpointsContext);

  const classes = classnames(styled.root, className, getClass(styled, `theme`, theme), {
    [styled.isMobile]: isMobile,
  });

  return (
    <div className={classes} style={style}>
      {options.map((option) => (
        <TabItem
          key={option.value as AnyType}
          {...option}
          itemClassName={itemClassName}
          onChange={handleChange}
          active={option.value === value}
        />
      ))}
    </div>
  );
};
